module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-GabrielleLabrie-Web-1280.504277b6.jpg";